<script lang="ts">
  import type { TextAccordionStoryblok } from "$types/components";
  import AccordionItem from "$lib/molecules/AccordionItem.svelte";
  import RichText from "./RichText.svelte";

  export let blok: TextAccordionStoryblok;

  let currentSlides: Set<number> = new Set([0]);

  const itemClicked: (event: CustomEvent<{ index: number }>) => void = ({
    detail: { index },
  }) => {
    if (!blok.alwaysOpen) {
      currentSlides = new Set([index]);
    } else if (currentSlides.has(index)) {
      currentSlides = new Set([...currentSlides].filter((i) => i !== index));
    } else {
      currentSlides = currentSlides.add(index);
    }
  };
</script>

<div class="slider-container">
  {#if $$slots.default}
    <slot />
  {/if}
  {#if blok && blok.items}
    <div class="slider-text">
      {#each blok.items as slide, index}
        <div class="slide-text">
          <AccordionItem
            on:click={itemClicked}
            {index}
            active={currentSlides.has(index)}
          >
            <div class="header" slot="header">
              <h6 class="type:h6-large">{slide.headline}</h6>
            </div>

            <div class="accordion" slot="body">
              <div class="accordion-inner">
                {#if typeof slide.text === "string"}
                  <p class="type:body-large">{slide.text}</p>
                {:else}
                  <RichText
                    class="type:body-large"
                    blok={{ content: slide.text }}
                  />
                {/if}
              </div>
            </div>
          </AccordionItem>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style lang="scss">
  .slider-text {
    .slide-text {
      border-top: 1px solid rgb(var(--color-stroke-dark));
    }

    .accordion-inner {
      padding-top: fluid(16px, 16px);
    }
  }
</style>
